export default __webpack_public_path__ + "static/media/41.d8a7a634.jpg";